export default "__VITE_ASSET__BpLltIWt__"